<template>
  <div
    class="msg_box"
  >
    <div
      v-if="results.over.length == 0 && results.lack.length == 0 && !success"
      class="msg_info"
    >
      <p>‘팩에 담을 제품’과 ‘하루에 섭취할 총 정/캡슐 개수’ 선택 후,</p>
      <span>‘함량계산’ 버튼을 선택해주세요.</span>
    </div>
    <div
      v-if="success"
      class="msg_success"
    >
      <p>알맞은 함량으로 구성되었습니다!</p>
      <span>다음 단계로 진행해주세요.</span>
    </div>
    <template v-else>
      <div
        v-if="results.over.length !== 0 || results.lack.length !== 0"
        class="msg_fail_wrap"
      >
        <div
          v-for="item in results.over"
          :key="item.item_sku"
          class="msg_fail"
        >
          <p>안타깝게도 {{ item.ingredientsName }}(이)가 초과되었어요</p>
          <template v-if="item.items.length > 2">
            <span>'<em>{{ item.items[0].itemName }}</em>'
              <template
                v-for="index in item.items.length - 1"
              >
                &nbsp;또는
                '<em :key="index">{{ item.items[index].itemName }}</em>'</template>
              수량을 줄여주세요!
            </span>
          </template>
          <template v-else-if="item.items.length === 2">
            <span
              class
            >'<em
              class
            >{{ item.items[0].itemName }}</em>' 또는 '<em
              class
            >{{ item.items[1].itemName }}</em>' 수량을 줄여주세요!</span>
          </template>
          <template v-else>
            <span>'<em>{{ item.items[0].itemName }}</em>' 수량을 줄여주세요!</span>
          </template>
        </div>
        <div
          v-for="item in results.lack"
          :key="item.item_sku"
          class="msg_fail"
        >
          <p>아쉽지만 {{ item.ingredientsName }}의 함량이 부족해요</p>
          <template v-if="item.items.length > 2">
            <span>'<em>{{ item.items[0].itemName }}</em>'
              <template
                v-for="index in item.items.length - 1"
              >
                &nbsp;또는
                '<em :key="index">{{ item.items[index].itemName }}</em>'</template>
              수량을 추가 해 보세요!
            </span>
          </template>
          <template v-else-if="item.items.length === 2">
            <span>'<em
              class
            >{{ item.items[0].itemName }}</em>' 또는 '<em
              class
            >{{ item.items[1].itemName }}</em>' 수량을 추가 해주세요!</span>
          </template>
          <template v-else>
            <span>'<em>{{ item.items[0].itemName }}</em>' 수량을 추가 해주세요!</span>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MessageBox',
  props: {
    success: {
      type: Boolean,
      default: null,
    },
    results: {
      type: Object,
      default: () => ({
        over: [],
        lack: [],
      }),
    },
  },
};
</script>
<style scoped>
em {
  font-weight: bold;
}
</style>
